/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useEffect, useState } from 'react';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import {
    createDateFromMaskInput,
    DATE_LONG_WITH_DAY_NAME,
    dateLongWithDayName,
    formatDate,
    formatFullDate,
} from '../../utils';
import './calendar.scss';

const dateMask = [ /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/ ];
const dateRegexp = /^[0-3]{1}[0-9]{1}[.]{1}[0-1]{1}[0-9]{1}[.]{1}[0-2]{1}[0-9]{3}$/;
const hint = 'DD/MM/YYYY';
const pipe = createAutoCorrectedDatePipe('dd/mm/yyyy');

const input = require('b_')
    .with('input');
const icon = require('b_')
    .with('icon');

export const CalendarInput = ({
    onChange,
    value,
    error,
    id,
    required,
    onBlur,
    formatView,
    disabled,
    onClickIcon,
    readOnly,
}) => {
    const [ displayValue, setDisplayValue ] = useState(null);
    useEffect(() => {
        if (value) {
            setDisplayValue(null);
        }
    }, [value]);

    const onManualChange = ({ target: { value: targetValue } }) => {
        if (dateRegexp.test(targetValue)) {
            const newDate = formatFullDate(createDateFromMaskInput(targetValue));
            onChange(newDate);
            setDisplayValue(targetValue);
        } else {
            setDisplayValue(targetValue);
            onChange(null);
        }
    };

    const viewValue =
        formatView === DATE_LONG_WITH_DAY_NAME
            ? dateLongWithDayName(value, 'Short')
            : displayValue || formatDate(value);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <i
                data-name="calendar--day"
                // onClick={!disabled && !readOnly && onClickIcon}
                className={icon({
                    color: 'blue_sapphire',
                    input: 'left',
                    'calendar--day': true,
                })}
            />
            <input
                value={value || ''}
                type="date"
                id="obw-datepicker"
                onChange={(v) => {
                    onChange(v.target.value);
                }}
                onBlur={(e) => {
                    if (onBlur) {
                        onBlur(e);
                    }
                }}
                style={{
                    // '-webkit-appearance': 'none',
                    // '-moz-appearance': 'none',
                    // appearance: 'none',
                    position: 'absolute',
                    width: '20px',
                    left: '5px',
                    opacity: 0,
                }}
            />
            {/* <input type="date" id="obw1-datepicker" style={{
                '-webkit-appearance': 'none',
                '-moz-appearance': 'none',
                appearance: 'none',
                // 'background-color': 'white',
                // border: '1px solid #ccc',
                // padding: '0.5em',
                // 'border-radius': '4px',
                position: 'absolute',
                width: '20px',
                left: '5px',
                opacity: 0,
            }} /> */}
            {(readOnly || formatView) ? (
                <input
                    id={id}
                    type="text"
                    value={viewValue}
                    required={required}
                    className={input({
                        icon: true,
                        error: !!error,
                    })}
                    disabled={disabled}
                    readOnly={readOnly}
                />
            ) : (
                <MaskedInput
                    id={id}
                    type="text"
                    value={viewValue}
                    required={required}
                    pipe={pipe}
                    maskhint={hint}
                    className={input({
                        icon: true,
                        error: !!error,
                    })}
                    mask={dateMask}
                    onBlur={onBlur}
                    onChange={onManualChange}
                    disabled={disabled}
                    showMask
                    guide
                    keepCharPositions
                />
            )}
        </>
    );
};
